import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
    View,
    Animated,
    Dimensions,
    PanResponder,
    Text,
    StyleSheet,
} from 'react-native';
import { ImageComp } from '../Image/Image';
import { ARROW_RIGHT } from '../../assets';
import { useCssStyle } from '../../customHook/getCssStyle';
import triggerHapticFeedback from '../../js/vibration/index';

const SCREEN_WIDTH = Dimensions.get('window').width;
const THUMB_SIZE = 50;

const SliderPressable = props => {

    const { text, handleOnSuccess } = props || {};

    const getStyles = useCssStyle();

    const translateX = useRef(new Animated.Value(0)).current;

    const containerWidthRef = useRef(0);
    const handleOnSuccessRef = useRef(handleOnSuccess);

    useEffect(() => {
    handleOnSuccessRef.current = handleOnSuccess;
    }, [handleOnSuccess]);

    const panResponder = useRef(
        PanResponder.create({
            onStartShouldSetPanResponder: (_, gestureState) => true,
            onPanResponderMove: (_, gestureState) => {                
                const maxX = containerWidthRef.current;
                const newX = Math.min(Math.max(0, gestureState.dx), maxX);
                translateX.setValue(newX);
            },
            onPanResponderRelease: (_, gestureState) => {
                const maxX = containerWidthRef.current;

                if (gestureState.dx > maxX * 0.6) {
                    triggerHapticFeedback("effectHeavyClick");
                    Animated.timing(translateX, {
                        toValue: maxX,
                        duration: 200,
                        useNativeDriver: false,
                    }).start(() => {        
                        setTimeout(() => {
                            handleOnSuccessRef.current?.();
                        }, 10);
                        setTimeout(() => {
                            Animated.spring(translateX, {
                                toValue: 0,
                                useNativeDriver: false,
                            }).start();
                        }, 200);
                    });
                } else {
                    Animated.spring(translateX, {
                        toValue: 0,
                        useNativeDriver: false,
                    }).start();
                }
            },
        }),
    ).current;

    const backgroundColorEffect = getStyles(["customSliderFillAnimated"])
    const backgroundColor = getStyles(["customSliderFill"]);

    const animatedBackgroundColor = translateX.interpolate({
        inputRange: [0, Math.max(containerWidthRef.current || SCREEN_WIDTH - THUMB_SIZE, 0)],
        outputRange: [backgroundColor?.backgroundColor, backgroundColorEffect?.backgroundColor],
        extrapolate: 'clamp',
    });

    return (
        <View style={getStyles(['customSliderContainer'])} 
            id='customSliderContainer'
            onLayout={(event) => {
                const { width } = event.nativeEvent.layout;
                containerWidthRef.current = width - 50;
            }}
        >

        <Animated.View
            style={getStyles([
                'customSliderFill', 
                {
                    width: Animated.add(translateX, new Animated.Value(10)),
                    backgroundColor: animatedBackgroundColor
                }
            ])}
            id={"customSliderFill customSliderFillAnimated"}
        />

            <Text style={getStyles(['customSliderText'])} id='customSliderText'>{text || "SLIDE TO CHECKIN"}</Text>
            <Animated.View
                {...panResponder.panHandlers}
                style={[
                    getStyles(['customSliderThumb']),
                    {
                        transform: [{ translateX }],
                    },
                ]}
                id="customSliderThumb"
            >
                <ImageComp
                    source={ARROW_RIGHT}
                    style={getStyles(['customSliderArrowIcon'])}
                    id="customSliderArrowIcon"
                />
            </Animated.View>
        </View>
    );
};

export default SliderPressable;
